export const UPDATE_ACCOUNT_HOLDER_USER = "UPDATE_ACCOUNT_HOLDER_USER"
export const UPDATE_ACCOUNT_HOLDER_USER_SUCCESS = "UPDATE_ACCOUNT_HOLDER_USER_SUCCESS"
export const UPDATE_ACCOUNT_HOLDER_USER_FAIL = "UPDATE_ACCOUNT_HOLDER_USER_FAIL"
export const CLEAR_ACCOUNT_HOLDER_USER = "CLEAR_ACCOUNT_HOLDER_USER"